import { render } from "./CustomerGroupsV2.vue?vue&type=template&id=0998f0a7&scoped=true"
import script from "./CustomerGroupsV2.vue?vue&type=script&lang=ts"
export * from "./CustomerGroupsV2.vue?vue&type=script&lang=ts"

import "./CustomerGroupsV2.vue?vue&type=style&index=0&id=0998f0a7&scoped=true&lang=css"
import "./CustomerGroupsV2.vue?vue&type=style&index=1&id=0998f0a7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0998f0a7"

export default script